/**
 * External Dependencies
 */

import 'jquery';
import '@popperjs/core';
import 'bootstrap';
import Isotope from 'isotope-layout';
import BigPicture from 'bigpicture';
import { createPopper } from '@popperjs/core/lib/createPopper';

$( window ).load(function() {
  var iso;
  var filters = {};

      setTimeout(() => {
        iso = new Isotope('.audio-grid', {
          itemSelector: '.grid-item',
          layoutMode : 'fitRows',
          filter: function() {
  
              var isMatched = true;
              var $this = $(this);
          
              for ( var prop in filters ) {
                var filter = filters[ prop ];
                // test each filter
                if ( filter ) {
                  isMatched = isMatched && $(this).is( filter );
                }
                // break if not matched
                if ( !isMatched ) {
                  break;
                }
              }
              return isMatched;
            }
        });
        
      }, 500);

      $('#filters').on( 'click', '.button', function() {
        var $this = $(this);
        // get group key
        //var $buttonGroup = $this.parents('.button-group');
        //var filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        filters[ 0 ] = $this.attr('data-filter');
        // arrange, and use filter fn
        iso.arrange();
      });

      $('#filters-mob').on( 'change', function() {
        var $this = $(this);
        // set filter for group
        filters[ 0 ] = this.value;
        //console.log(filters);
        // arrange, and use filter fn
        iso.arrange();
      });
      
      // change is-checked class on buttons
      $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        $buttonGroup.on( 'click', 'button', function() {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $( this ).addClass('is-checked');
        });
      });

      $('#video_container .play').on('click', function(e) {
        let elem = $(e.currentTarget);
        let classes =  $(e.currentTarget).attr('class');
        var bp;
        if (classes.indexOf('htmlvid') !== -1) {
           bp = BigPicture({
            el: e.currentTarget,
            vidSrc: elem.attr('vidSrc'),
          });
        } else if (classes.indexOf('vimeo') !== -1) {
          bp = BigPicture({
            el: e.currentTarget,
            vimeoSrc: elem.attr('vimeoSrc'),
          });
        } else if (classes.indexOf('youtube') !== -1) {
          bp = BigPicture({
            el: e.currentTarget,
            ytSrc: elem.attr('ytSrc'),
          });
        }
        bp.display.removeAttribute('loop');
      });
});
